export default ({ primary, keyboardBackground }) => ({
  '.ui-keyboard-accept': {
    backgroundColor: `${primary} !important`,
  },
  '.ui-keyboard': {
    backgroundColor: keyboardBackground,
  },
});
